import PowerDate from '#metatypes/power_date.js'
import PowerBool from '#metatypes/power_bool.js'
import { define, type, auto, Record, Collection } from 'type-r'
import ConsentForm from './consent'
import { createEnum } from '#metatypes/enum.js'

@define
export default class SkinCancerForm extends ConsentForm {
    @(type(PowerBool).required.as) offeredCopy: boolean
    @(type(createEnum('Right', 'Left', 'Both')).required.as) side: string
    @(type(String).as) other: string
}
